<template>
<el-main v-loading="loading"
        element-loading-text="Please wait.."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.4)">
    <div class="register" v-if="!isValidForm" >
        <div style="text-align: center;">
            <img src="../public/logo.png" alt="logo" style="width: 60%;" />
        </div>
        <h5>
            As new user of Berst you are eligible for a free 30 day trial starting from the time you receive email confirmation of your room being created.
        </h5>
        <h5>
            At the end of your free trial your account will be converted to a standard paid account.
        </h5>
        <h5>
            By registering you’ll have access to your own room, and have the ability to create as many breakout rooms as you’d like under your meeting room chain.
        </h5>
        <el-form ref="form" :rules="rules" :model="form">
            <div>
                <h5>Name</h5>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="firstName">
                            <el-input v-model="form.firstName"></el-input>
                        </el-form-item>
                        <p>First Name</p>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="lastName">
                            <el-input v-model="form.lastName"></el-input>
                        </el-form-item>
                        <p>Last Name</p>
                    </el-col>
                </el-row>
            </div>
            <div class="main-room">
                <h6>Mainroom name</h6>
                <el-form-item prop="mainRoom" inline-message="true">
                    <el-input v-model="form.mainRoom"></el-input>
                </el-form-item>
                <p>The text that will be displayed that will identify all rooms in your meeting room chain. (%, /, ? and # symbols are not allowed)</p>
            </div>
            <div>
                <h5>Email</h5>
                <el-form-item prop="email">
                    <el-input v-model="form.email"></el-input>
                </el-form-item>
            </div>
            <div>
                <h5>Billing address</h5>
                <div>
                    <el-form-item prop="billingAddress.address1">
                        <el-input type="textarea" v-model="form.billingAddress.address1"></el-input>
                    </el-form-item>
                    <p>Address 1</p>
                </div>
                <div>
                    <el-form-item prop="billingAddress.address2">
                        <el-input type="textarea" v-model="form.billingAddress.address2"></el-input>
                    </el-form-item>
                    <p>Address 2</p>
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div>
                            <el-form-item prop="billingAddress.city">
                                <el-input v-model="form.billingAddress.city"></el-input>
                            </el-form-item>
                            <p>City</p>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            <el-form-item prop="billingAddress.state">
                                <el-input v-model="form.billingAddress.state"></el-input>
                            </el-form-item>
                            <p>State/Province</p>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div>
                            <el-form-item prop="billingAddress.zipCode">
                                <el-input v-model="form.billingAddress.zipCode"></el-input>
                            </el-form-item>
                            <p>Zip/Postal Code</p>
                        </div>
                    </el-col>
                </el-row>
                <div>
                    <el-form-item prop="billingAddress.country">
                        <el-input v-model="form.billingAddress.country"></el-input>
                    </el-form-item>
                    <p>Country</p>
                </div>
            </div>
            <div class="gst">
                <h6>
                    Are you based in, or have significant operations in
                    Australia
                </h6>
                <div>
                    Berst is an Australian company and must
                    charge GST if you are based in, or have significant
                    operations in Australia
                </div>
                <el-form-item prop="isAustralian">
                    <el-radio-group v-model="form.isAustralian">
                        <el-radio label="Yes"></el-radio>
                        <el-radio label="No"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div class="terms-condition">
                <h6>Terms and conditions</h6>
                <el-form-item prop="termsAndCondition">
                    <el-checkbox v-model="form.termsAndCondition" name="type">"I accept the <a href='https://www.berst.io/terms-and-conditions.html' target="_blank">terms and conditions</a> of use of Berst Pty Ltd"
                    </el-checkbox>
                </el-form-item>
            </div>
            <el-form-item prop="recaptcha" style="margin-top:20px;">
                <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSitekey" :loadRecaptchaScript="true"></vue-recaptcha>
            </el-form-item>
            <div style="text-align: center; margin: 30px 0 0 0;">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">Register</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
    <payment :add-payment-details="this.addPaymentDetails" v-if="this.isValidForm"/>
</el-main>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import axios from './client';
import payment from './Payment.vue';
import { showMessage } from './utils';
import { mapState } from 'vuex';

export default {
    name: 'Register',
    components: {
        VueRecaptcha,
        payment
    },
    data() {
        const validateRoomName = async (rule, value, callback) => {
            let url = `api/rooms/${value}/exists`;
            const result = await axios.get(url);
            if (result.data && result.data.exists === false) {
                callback();
            } else {
                callback(new Error());
            }
        };

        return {
            isValidForm: false,
            recaptchaSitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            paymentDetails: null,
            planType: 'Monthly Plan',
            form: {
                firstName: '',
                lastName: '',
                mainRoom: '',
                email: '',
                billingAddress: {
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    country: ''
                },
                isAustralian: '',
                termsAndCondition: false,
                recaptcha: ''
            },
            rules: {
                firstName: [{
                    required: true,
                    message: 'Please enter first name',
                    trigger: 'blur'
                }],
                lastName: [{
                    required: true,
                    message: 'Please enter last name',
                    trigger: 'blur'
                }],
                mainRoom: [{
                        required: true,
                        message: 'Please enter main room name',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: 'Please enter valid main room name',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/
                    },
                    {
                        required: true,
                        message: 'Room name already exists',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/,
                        validator: validateRoomName
                    }
                ],
                email: [{
                        required: true,
                        message: 'Please enter email',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        required: true,
                        message: 'Please enter valid email',
                        trigger: 'blur'
                    }
                ],
                'billingAddress.address1': [{
                    required: true,
                    message: 'Please enter biiling address',
                    trigger: 'blur'
                }],
                'billingAddress.zipCode': [{
                    required: true,
                    message: 'Please enter zip/postal code',
                    trigger: 'blur'
                }],
                'billingAddress.city': [{
                    required: true,
                    message: 'Please enter the city',
                    trigger: 'blur'
                }],
                'billingAddress.state': [{
                    message: 'Please enter the state',
                    trigger: 'blur'
                }],
                'billingAddress.country': [{
                    required: true,
                    message: 'Please enter the country name',
                    trigger: 'blur'
                }],
                isAustralian: [{
                    required: true,
                    message: 'Please check on of the value',
                    trigger: ['change', 'blur']
                }],
                termsAndCondition: [{
                    required: true,
                    message: 'Please accept terms and conditions',
                    trigger: 'change',
                    pattern: /true/
                }],
                recaptcha: [{
                    required: true,
                    message: 'Please verify the captcha',
                    trigger: ['change', 'blur']
                }]
            }
        };
    },
    methods: {
        submitForm(form) {
            if (
                this.$refs[form].validate(valid => {
                    if (valid && this.form.recaptcha) {
                        this.$store.commit('updateRegistrationForm', {
                            formData: this.form
                        });
                        this.isValidForm = true;
                    } else {
                        return false;
                    }
                })
            );
        },

        onCaptchaVerified(recaptchaToken) {
            this.form.recaptcha = recaptchaToken;
            this.$refs.form.validateField('recaptcha');
        },

        onCaptchaExpired() {
            this.form.recaptcha = '';
            this.$refs.recaptcha.reset();
        },

        addPaymentDetails(paymentDetails, planType) {
            this.paymentDetails = paymentDetails;
            this.planType = planType;
            this.registerUser();
        },

        async registerUser() {
            if (this.isValidForm && this.form.recaptcha) {
                try {
                    this.$store.commit('user/setAuthLoading', true);
                    const url = '/api/rooms/register/';
                    await axios.post(url, {
                        card: this.paymentDetails,
                        userData: this.form,
                        planType: this.planType
                    });
                    this.$message({
                        message: 'Congrats, Your registration is successful',
                        type: 'success'
                    });
                    this.$router.push({
                        path: '/registrationsuccess'
                    });
                } catch (error) {
                    this.$store.commit('user/setAuthLoading', false);
                    if(error.response.data.message === 'ROOM_OWNER_EXIST'){
                        showMessage('You are already a own owner. Try adding a new room from the dashboard','error')
                    }
                    else if (error.response.data.message === 'PAYMENT_FAILED') {
                        showMessage('Please check your card details again and contact your card issuer if the issue persists','error')
                    } else if (error && error.form) {
                        this.$message({
                            message: 'Unable to process your registration details',
                            type: 'error'
                        });
                        this.isValidForm = false;
                    } else {
                        this.$message({
                            message: 'Something went wrong please try again',
                            type: 'error'
                        });
                        this.isValidForm = false;
                    }
                }
            } else {
                return false;
            }
            this.$store.commit('user/setAuthLoading', false);

        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.user.authLoading,
        }),
    },
};
</script>

<style scoped>
.register {
    max-width: 700px;
    margin: 0 auto;
    text-align: left;
}

.el-main {
    height: 100%;
    overflow-y: scroll;
    margin-left: 0 !important;
}

.el-form-item__content {
    margin-left: 0 !important;
}

p,
h5,
h6 {
    margin: 10px 0;
}

p {
    font-size: 12px;
    margin-top: 2px;
    margin-left: 1px;
}

.main-room,
.gst {
    margin: 20px 0px;
}

.main-room h6,
.gst h6,
.terms-condition h6 {
    font-size: 14px;
}

.main-room div,
.gst div {
    font-size: 12px;
}

.el-form-item {
    margin-bottom: 0 !important;
}
</style>

<style>
.el-form-item.is-success .el-input__inner {
    border-color: #dcdfe6 !important
}

.el-form-item__error {
    position: relative !important;
}
</style>
